export default __webpack_public_path__ + "static/media/yellow_warning.9f88e72a.svg";